var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup454(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H39V39H0z",
    transform: "translate(-735 -604) translate(735 604)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#57834f",
    strokeLinecap: "round",
    strokeWidth: "2.5px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 19.424",
    transform: "translate(-735 -604) rotate(-90 687.104 -57.07) translate(6.508)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M0 0l6.534 7.161L13.067 0",
    transform: "translate(-735 -604) rotate(-90 687.104 -57.07) translate(0 13.491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup454);
export default __webpack_public_path__ + "static/media/Group 454.33d7535421b1df969b7883f8075cbef2.svg";
export { ForwardRef as ReactComponent };